import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { useBlogImportHistoryInvalidation } from './useBlogImportHistoryQuery';

interface Params {
	systemJobId: string;
	accountId: string;
}

export function useBlogImportRevertMutation({
	onError,
	onSuccess,
}: {
	onError?: (err: Api.IOperationResultNoValue) => void;
	onSuccess?: (val: boolean) => void;
} = {}) {
	const userSession = useUserSession();
	const { invalidateBlogImportHistory } = useBlogImportHistoryInvalidation();

	return useMutation({
		mutationFn: async ({ systemJobId, accountId }: Params) => {
			const value = await userSession.webServiceHelper.callAsync<boolean>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext: { account: { id: accountId } },
					urlPath: `blog/imports/${systemJobId}/revert`,
				}),
				'POST'
			);
			return value;
		},
		onError,
		onSuccess: (data, variables) => {
			invalidateBlogImportHistory(variables.accountId);
			onSuccess?.(data);
		},
	});
}
